import React from "react";
export default function ArrowStub({ style }) {
    return (React.createElement("svg", { style: style, viewBox: "0 0 210 500" },
        React.createElement("path", { d: "M 2.517 12.887 C 2.517 -5.789 25.654 -2.735 37.223 12.887 L 195.323 226.377 C 206.892 241.998 206.892 257.618 195.323 273.24 L 37.223 486.729 C 25.654 502.35 2.517 506.383 2.517 486.729 L 2.517 12.887 Z" })));
}
